import { css } from 'lit';

export const commonStyles = css`
  * {
    box-sizing: border-box;
  }

  /* Material 3 Motion System - Now Global in index.css */
  :host {
    /* Variables moved to :root */
  }

  /* Typography Helpers */
  .display-large { font: var(--tfp-md-typescale-display-large); }
  .display-medium { font: var(--tfp-md-typescale-display-medium); }
  .display-small { font: var(--tfp-md-typescale-display-small); }
  .headline-large { font: var(--tfp-md-typescale-headline-large); }
  .headline-medium { font: var(--tfp-md-typescale-headline-medium); }
  .headline-small { font: var(--tfp-md-typescale-headline-small); }
  .title-large { font: var(--tfp-md-typescale-title-large); }
  .title-medium { font: var(--tfp-md-typescale-title-medium); }
  .title-small { font: var(--tfp-md-typescale-title-small); }
  .label-large { font: var(--tfp-md-typescale-label-large); }
  .label-medium { font: var(--tfp-md-typescale-label-medium); }
  .label-small { font: var(--tfp-md-typescale-label-small); }
  .body-large { font: var(--tfp-md-typescale-body-large); }
  .body-medium { font: var(--tfp-md-typescale-body-medium); }
  .body-small { font: var(--tfp-md-typescale-body-small); }

  /* Elevation Helpers */
  .elevation-0 { box-shadow: var(--tfp-md-elevation-level-0); }
  .elevation-1 { box-shadow: var(--tfp-md-elevation-level-1); }
  .elevation-2 { box-shadow: var(--tfp-md-elevation-level-2); }
  .elevation-3 { box-shadow: var(--tfp-md-elevation-level-3); }
  .elevation-4 { box-shadow: var(--tfp-md-elevation-level-4); }
  .elevation-5 { box-shadow: var(--tfp-md-elevation-level-5); }

  .material-symbols-outlined {
    font-family: 'Material Symbols Outlined';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: normal;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
  }

  /* =========================================
     Kinetic Obsidian helpers
     Uppercase tracked section labels + tinted metric badges.
     Badges use color-mix tints (never literal rgba) so they follow the
     space-separated triplet / theme-switched convention. In light mode the
     glow tokens already drop to tonal values (index.css), so no per-mode
     badge rules are needed here.
     ========================================= */
  /* Section titles (card headers). Used only for those — the small variant
     below stays for dense chips/labels. label-large (14px) so the caps title
     reads as a title, not body metadata. */
  .label-caps {
    font: var(--tfp-md-typescale-label-large);
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }
  .label-caps-sm {
    font: var(--tfp-md-typescale-label-small);
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 10px;
    border-radius: var(--tfp-md-shape-corner-full);
    border: 1px solid transparent;
    font: var(--tfp-md-typescale-label-small);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    white-space: nowrap;
  }
  /* Success / on-track — primary */
  .badge-primary {
    color: var(--tfp-md-color-primary);
    background-color: color-mix(in srgb, var(--tfp-md-color-primary) 12%, transparent);
    border-color: color-mix(in srgb, var(--tfp-md-color-primary) 35%, transparent);
  }
  /* Rest / neutral */
  .badge-neutral {
    color: var(--tfp-md-color-on-surface-variant);
    background-color: color-mix(in srgb, var(--tfp-md-color-on-surface-variant) 8%, transparent);
    border-color: color-mix(in srgb, var(--tfp-md-color-on-surface-variant) 15%, transparent);
  }
  /* Urgent / overdue */
  .badge-error {
    color: var(--tfp-md-color-error);
    background-color: color-mix(in srgb, var(--tfp-md-color-error) 12%, transparent);
    border-color: color-mix(in srgb, var(--tfp-md-color-error) 35%, transparent);
  }
  /* Caution / advisory (Stitch mapping SH-05); uses the app's warning accent */
  .badge-warning {
    color: var(--tfp-md-color-accent-yellow);
    background-color: color-mix(in srgb, var(--tfp-md-color-accent-yellow) 12%, transparent);
    border-color: color-mix(in srgb, var(--tfp-md-color-accent-yellow) 35%, transparent);
  }

  /* Advisory callout card (Stitch mapping SH-05) — e.g. the evaluation
     guidelines "esse processo é primordial" warning. Tinted surface + leading
     icon slot; no backdrop-blur, works in both themes via token mixing. */
  .callout {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    border-radius: var(--tfp-md-shape-corner-medium);
    background-color: color-mix(in srgb, var(--tfp-md-color-accent-yellow) 8%, var(--tfp-md-color-surface-container));
    border: 1px solid color-mix(in srgb, var(--tfp-md-color-accent-yellow) 30%, transparent);
    color: var(--tfp-md-color-on-surface);
    text-align: left;
  }
  .callout .material-symbols-outlined {
    font-size: 20px;
    color: var(--tfp-md-color-accent-yellow);
    flex-shrink: 0;
  }
`;

